const fromdataedit = [
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    disabled: false,
    lablewith: "60px",
    options: [],
  },
  {
    inputdata: "",
    title: "经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "autocompletePer",
    width: "200px",
    // btx: true,
    lablewith: "60px",
    options: [],
    selcoms: false,
  },
  // {
  //   inputdata: "",
  //   title: "配送商类型",
  //   fontSize: "14px",
  //   color: "#333333",
  //   placeholder: "请选择",
  //   types: "",
  //   inputtype: "select",
  //   width: "210px",
  //   disabled: true,
  //   lablewith: "120px",
  //   options: [],
  //   options: [],
  //   selcoms: true,
  // },
    {
    inputdata: "",
    title: "下级经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "selectautocompleteHosType",
    width: "190px",
    lablewith: '100px',
    // event: "JXSUPChage",
  },
  {
    inputdata: "",
    title: "指定配送商/采购代理",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "selectautocompleteHB",
    width: "210px",
    lablewith: '120px',
    disabled: false
    // event: "JXSUPChage",
  },

  {
    inputdata: "",
    title: "医院",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompletes",
    width: "210px",
    lablewith: "60px",
    options: [],
  },
  {
    inputdata: "",
    title: "备案文件有效期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "dates",
    width: "140px",
    lablewith: "105px",
    widths: "190px",
  },
  {
    inputdata: "",
    title: "是否终端医院发票",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "text",
    inputtype: "radio",
    // width: "300px",
    radiotitle1: "是",
    radiotitle2: "否",
    lablewith: "120px",
    // radio: "1",
  },
  {
    inputdata: "",
    title: "备注",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "850px",
    lablewith: "60px",
  },
 
];
export default fromdataedit;
